import Text from "@mui/material/Typography";

const RequiredQuestion = () => {
    return (
        <Text as="p" align="right" style={{marginBottom: "30px"}}><small style={{fontStyle: "italic"}}>* Required question.</small></Text>
    )
}

export default RequiredQuestion
